import { useCallback, useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Button, Divider, Paper, Typography } from '@mui/material';
import { Settings } from '../../../interfaces/Settings/Settings';
import { getSettingsByType, upsertSettings } from '../../../api/Settings';
import { SettingsType } from '../../../interfaces/Settings/SettingsType';
import { GenericSettingsValue } from '../../../interfaces/Settings/GenericSettingsValue';
import { getSettingsValue, getUpdatedSettings } from '../../../utils/Settings';
import { Waiting } from '../../../components/Waiting/Waiting';
import { sharedStyles } from '../../../utils/Style';
import { SettingsRow } from '../../../components/Settings/SettingsRow';
import { SettingsValueType } from '../../../interfaces/Settings/SettingsValueType';

export const InvoiceSenderSettings = () => {
  const [settings, setSettings] = useState<Settings[]>([]);
  const [loading, setLoading] = useState(true);

  const refreshSettings = () => {
    setLoading(true);
    getSettingsByType(SettingsType.INVOICE)
      .then((s) => setSettings(s))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshSettings();
  }, []);

  const handleChange = useCallback(
    (key: string, newValue: GenericSettingsValue) =>
      setSettings(
        getUpdatedSettings(SettingsType.INVOICE, key, settings, newValue),
      ),
    [settings],
  );

  const handleSave = () => {
    setLoading(true);
    upsertSettings(settings)
      .then(() => {
        toast.success('Ayarlar başarıyla kaydedildi');
        refreshSettings();
      })
      .catch((err) => {
        toast.error(err.message);
        setLoading(false);
      });
  };

  return (
    <Paper
      sx={{
        p: 1.5,
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        height: '95%',
      }}
    >
      <Waiting open={loading} />
      <Typography
        sx={{
          ...sharedStyles.h5,
          fontWeight: 'bold',
        }}
      >
        Gönderici Ayarları
      </Typography>
      <Divider />

      <SettingsRow
        name='VKN'
        valueType={SettingsValueType.TEXT}
        value={getSettingsValue(settings, 'invoice_sender_vkn')}
        onChange={(newValue) => handleChange('invoice_sender_vkn', newValue)}
      />
      <SettingsRow
        name='Ünvan'
        valueType={SettingsValueType.TEXT}
        value={getSettingsValue(settings, 'invoice_sender_title')}
        onChange={(newValue) => handleChange('invoice_sender_title', newValue)}
      />
      <SettingsRow
        name='Gönderici Birim'
        valueType={SettingsValueType.TEXT}
        value={getSettingsValue(settings, 'invoice_sender_alias')}
        onChange={(newValue) => handleChange('invoice_sender_alias', newValue)}
      />
      <SettingsRow
        name='E-Posta'
        valueType={SettingsValueType.TEXT}
        value={getSettingsValue(settings, 'invoice_sender_email')}
        onChange={(newValue) => handleChange('invoice_sender_email', newValue)}
      />

      <Box sx={{ display: 'flex', flexGrow: 1 }} />
      <Box display='flex' justifyContent='flex-end'>
        <Button
          variant='contained'
          onClick={handleSave}
          sx={{ ...sharedStyles.buttonText, mt: 1.5 }}
        >
          Kaydet
        </Button>
      </Box>
    </Paper>
  );
};
